import React from "react";
import CmsManager from "./CmsManager";

function ClientsManager() {
  return (
    <CmsManager
      title="Our Clients"
      resource="clients"
      supportsReorder
      fields={[
        { name: "name", label: "Client Name", required: true, fullWidth: false },
        {
          name: "category",
          label: "Client Type",
          type: "select",
          required: true,
          fullWidth: false,
          options: [
            { value: "", label: "Select client type" },
            { value: "corporate", label: "Corporate Client" },
            { value: "retail", label: "Retail Client" },
            { value: "warehouse", label: "Warehouse Client" },
            { value: "investment", label: "Investment Client" },
            { value: "interior", label: "Interior Client" },
          ],
        },
        { name: "slug", label: "URL Slug", fullWidth: false },
        {
          name: "logo",
          label: "Client Logo",
          type: "image",
          required: true,
          objectFit: "contain",
          fullWidth: false,
        },
        { name: "altText", label: "Logo Alt Tag", fullWidth: false },
        {
          name: "testimonial",
          label: "Testimonial (Optional)",
          type: "textarea",
          rows: 5,
          placeholder: "Client review, including attribution where applicable",
        },
        {
          name: "testimonialAuthor",
          label: "Testimonial Author",
          fullWidth: false,
        },
        {
          name: "testimonialDesignation",
          label: "Author Designation",
          fullWidth: false,
        },
        {
          name: "testimonialCompany",
          label: "Author Company",
          fullWidth: false,
        },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        {
          name: "metaDescription",
          label: "Meta Description",
          type: "textarea",
          rows: 3,
        },
        {
          name: "metaKeywords",
          label: "Meta Keywords",
          type: "keywords",
          rows: 2,
        },
      ]}
    />
  );
}

export default ClientsManager;
